import React from "react";
import { Card, TooltipIcon } from "@sscs/ui";
import { ASSESSMENT_CATEGORY_ORDER } from "../../../constants";
import AssessmentCard from "./AssessmentCard/AssessmentCard";
import styles from "./riskCards.module.scss";
const CategoryList = ({ riskAssessment, policyCountByRisk, renderAssessmentCard, }) => {
    return (React.createElement("div", { className: styles.grid }, ASSESSMENT_CATEGORY_ORDER.map((assessmentCategory) => renderAssessmentCard({
        key: assessmentCategory,
        assessmentCategory,
        riskAssessment: riskAssessment[assessmentCategory],
        policyCount: policyCountByRisk[assessmentCategory],
    }))));
};
const RiskCardsPanel = ({ helperText, children, }) => {
    return (React.createElement(Card.Card, null,
        React.createElement(Card.Title, { details: [
                React.createElement(TooltipIcon, { key: "tooltip", size: "xs", title: React.createElement(React.Fragment, null, "A high-level overview of key risks or safety concerns found in your software. Detected risks are grouped according to their shared characteristics. This helps identify, prioritize, and mitigate issues based on the category they belong to.") }),
            ], actions: helperText }, "SAFE assessment evaluations"),
        React.createElement(Card.Content, null, children)));
};
export default {
    Panel: RiskCardsPanel,
    CategoryList,
    AssessmentCard,
};
//# sourceMappingURL=RiskCards.js.map